import { useState } from "react";
import { Link } from "react-router-dom";
import { Nav } from "@/components/site/Nav";
import { Seo } from "@/components/Seo";
import { api } from "@/lib/api";

export default function Unsubscribe() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | sending | done

  const submit = async (e) => {
    e.preventDefault();
    setState("sending");
    try {
      await api.post("/newsletter/unsubscribe", { email });
    } catch (err) { /* always confirm to avoid enumeration */ }
    setState("done");
  };

  return (
    <div className="min-h-screen bg-cream text-olive-deep">
      <Seo title="Meld av nyhetsbrev – Helserebellen" description="Meld deg av nyhetsbrevet fra Helserebellen." path="/avmelding" noindex />
      <Nav />
      <main className="min-h-screen grid place-items-center px-6">
        <div className="w-full max-w-md text-center">
          <p className="font-script text-4xl text-terra">Avmelding</p>
          <h1 className="mt-2 font-serif text-4xl">Meld av nyhetsbrev</h1>
          {state === "done" ? (
            <p className="mt-6 text-olive/75" data-testid="unsub-done">Takk – hvis e-posten var påmeldt, er den nå meldt av.</p>
          ) : (
            <form onSubmit={submit} className="mt-8 space-y-4" data-testid="unsub-form">
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="unsub-email" placeholder="Din e-post"
                className="w-full rounded-md border border-olive/25 bg-cream-deep/40 px-4 py-3 text-olive-deep placeholder:text-olive/40 focus:outline-none focus:border-terra" />
              <button type="submit" disabled={state === "sending"} data-testid="unsub-submit"
                className="w-full rounded-md bg-terra px-6 py-3 text-cream text-[12px] font-semibold uppercase tracking-[0.1em] hover:bg-olive-deep transition-colors disabled:opacity-60">
                {state === "sending" ? "Melder av…" : "Meld meg av"}
              </button>
            </form>
          )}
          <div className="mt-8">
            <Link to="/" className="text-olive/60 text-sm hover:text-terra">← Til forsiden</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
